import type { ReactNode } from 'react'
import React from 'react'

import * as S from './ButtonGroup.styled'

type ButtonGroupProps = {
  space?: 'small' | 'medium' | 'large' | 'xlarge'
  justify?: 'left' | 'right'
  align?: 'center' | 'stretch'
  direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse'
  fullWidth?: boolean
  children: ReactNode
}

export const ButtonGroup = ({
  space = 'small',
  justify = 'left',
  align,
  direction = 'row',
  fullWidth = false,
  children,
}: ButtonGroupProps) => {
  return (
    <S.Group
      $justify={justify}
      $align={align}
      $direction={direction}
      $fullWidth={fullWidth}
      $space={space}
    >
      {children}
    </S.Group>
  )
}
